import React from 'react';
import { Button, CircularProgress } from '@mui/material';

const CustomButton = ({ 
    children, 
    onClick, 
    variant = 'contained', // MUI default is 'contained'
    color = 'primary', // MUI default color is 'primary'
    size = 'medium', // MUI default size is 'medium'
    disabled = false, 
    loading = false, 
    style = {}, 
    ...props 
}) => {
    return (
        <Button
            variant={variant}
            color={color}
            size={size}
            onClick={onClick}
            disabled={disabled}
            sx={{
                ...style,
                '&:hover': {
                    backgroundColor: 'rgba(7, 222, 64, 0.6)', color: 'rgb(3, 79, 23)' // Change to your desired active background color
                },
                '&:active': {
                    backgroundColor: 'rgba(50, 225, 75, 0.6)', color: 'rgb(3, 79, 23)'// Change to your desired active background color
                },
            }}            {...props}
            startIcon={loading ? <CircularProgress size={20} sx={{color:"white"}} /> : null} // Optional loading state
        >
            {children}
        </Button>
    );
};

export default CustomButton;
